const applicationDataRQKeys = {
  all: ['applicationData'],
  previews: () => [applicationDataRQKeys.all, 'previews']
}

export default applicationDataRQKeys
